import { Layer, Page } from 'ui/components'
import { TemplatesListContextProvider } from '~bank-document-templates/list/context'

import { Actions, Filter, TemplatesTable } from './components'

export default () => (
  <TemplatesListContextProvider>
    <Page title="Template Manager" actions={<Actions />}>
      <Layer rounded shadowed stretch>
        <Filter />
        <TemplatesTable />
      </Layer>
    </Page>
  </TemplatesListContextProvider>
)
